import { Component, EventEmitter, Output, inject, ChangeDetectionStrategy } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { FormsModule } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";

import { ApiService } from "src/app/api.service";
import { ActionButtonComponent } from "src/app/shared/action-button/action-button.component";
import { APIResults } from "src/app/sharedinterfaces";

declare const BrandVars;

@Component({
	selector: "app-manage-fleet",
	templateUrl: "./manage-fleet.component.html",
	styleUrls: ["./manage-fleet.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [FormsModule, ActionButtonComponent]
})
export class ManageFleetComponent {
	private api = inject(ApiService);
	private router = inject(Router);
	private route = inject(ActivatedRoute);

	@Output()
	UpdateTree: EventEmitter<void> = new EventEmitter<void>();

	public fleet: APIResults.Fleet;

	public orgConfigs: APIResults.AssetConfig[] = [];
	public newAsset: any = {};
	public newAssetAuth: string;

	constructor() {
		this.route.params.pipe(takeUntilDestroyed()).subscribe((params) => {
			this.RefreshFleet(Number(params["fleetid"]) || undefined);
			this.RefreshConfigs(Number(params["orgid"]));
		});
	}

	public async RefreshFleet(fleet_id?: number) {
		this.fleet = undefined;
		if (fleet_id) this.fleet = await this.api.GetFleet(fleet_id);
	}

	public async RefreshConfigs(organization_id: number) {
		this.orgConfigs = [];
		this.orgConfigs = await this.api.GetAssetConfigs(organization_id);
	}

	public async UpdateFleet() {
		await this.api.ChangeOrgFleet(this.fleet.organization_id, this.fleet.fleet_id, this.fleet.time_offset_hours, this.fleet.hidden);
		// Nothing here affects the treeview
		// this.updateTree.emit();
	}

	public async DeleteFleet() {
		await this.api.DeleteFleet(this.fleet.organization_id, this.fleet.fleet_id);
		this.router.navigate(["/admin/assets/org", this.fleet.organization_id]);
		this.UpdateTree.emit();
	}

	public async FreshenSerial() {
		const fresh = await this.api.GetCoordinatorSerial(BrandVars.serialPrefix);
		this.newAsset.obcu_serial_number = fresh;
	}

	public async AddAsset() {
		this.newAssetAuth = undefined;
		if (!(this.newAsset.asset_name && this.newAsset.obcu_serial_number)) {
			throw new Error("Asset name & Server ID required");
		}
		const prefix = BrandVars.serialPrefix ? "FX" : "MX";
		const serialdata = {
			creator: this.api.user.email,
			environment: BrandVars.apiRoot,
			asset_type: prefix,
		};
		const orgid = this.fleet?.organization_id || this.route.snapshot.params["orgid"];
		const fleetid = this.fleet?.fleet_id;
		await this.api.SaveCoordinatorSerial(this.newAsset.obcu_serial_number, serialdata);
		const result = await this.api.AddAsset(orgid, fleetid, this.newAsset.asset_type_id, this.newAsset.asset_name, this.newAsset.obcu_serial_number);
		this.UpdateTree.emit();
		this.newAssetAuth = result.auth;
	}

}
